import { Stack, PrimaryButton } from "@fluentui/react";
import { ErrorCircle24Regular } from "@fluentui/react-icons";

import styles from "./Answer.module.css";

interface Props {
    error: string;
    errorTime?: string;
    onRetry: () => void;
}

export const AnswerError = ({ error, errorTime, onRetry }: Props) => {
    const time = errorTime && new Date(errorTime).toLocaleTimeString();

    return (
        <Stack className={styles.answerContainer} verticalAlign="space-between">
            <ErrorCircle24Regular aria-hidden="true" aria-label="Error icon" className={styles.errorIcon} />

            <Stack.Item grow>
                <p className={styles.answerText}>
                    {error.split("\n").map((i, key) => (
                        <div key={key}>{i}</div>
                    ))}
                </p>
            </Stack.Item>

            <PrimaryButton className={styles.retryButton} onClick={onRetry} text="Retry" />
            {time && <div className={styles.time}>{time}</div>}
        </Stack>
    );
};
